export default __webpack_public_path__ + "static/media/50.fb13d07c.jpeg";